import { useState } from "react";
import useCalendarEventKlydos from "./useCalendarEventKlydos";
import { GetCalendarEventKlydosInput } from "../../../api/klydo";

interface UseLoadKlydosProps extends GetCalendarEventKlydosInput {
  enabled?: boolean;
}

const useLoadKlydos = ({
  country,
  year,
  month,
  day,
  state,
  enabled = true,
}: UseLoadKlydosProps) => {
  const [klydosEnabled, setKlydosEnabled] = useState(false);

  const {
    data: populatedEvents,
    isLoading: klydosLoading,
    error: klydosError,
  } = useCalendarEventKlydos({
    country,
    year,
    month,
    day,
    state,
    enabled: klydosEnabled && enabled,
  });

  const handleLoadKlydos = () => {
    setKlydosEnabled(true);
  };

  return {
    populatedEvents,
    klydosLoading,
    klydosError,
    handleLoadKlydos,
    klydosLoaded: !!populatedEvents,
    klydosEnabled,
  };
};

export default useLoadKlydos;
